import { useState } from "react";
import moment from "moment-timezone";
import DynamicAutocomplete from "../AutoSuggestion/DynamicAutocomplete";

const time_zones = moment.tz.names().map((tz) => ({
  label: tz,
  value: tz,
}));

const normalizeTimezoneSearch = (value) =>
  value.toLowerCase().replace(/[_/\s-]+/g, " ").trim();

const TimezoneSelector = ({ selectedTimezone, onTimezoneChange, selectStyle }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (timezone) => {
    if (onTimezoneChange) {
      onTimezoneChange(timezone?.value || "");
    }
  };

  return (
    <DynamicAutocomplete
      options={time_zones}
      value={time_zones.find((timezone) => timezone.value === selectedTimezone) || null}
      onChange={handleChange}
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      onInputChange={(_, value, reason) => {
        if (reason === "input" || reason === "clear") setIsOpen(true);
      }}
      placeholder="Select Timezone"
      openOnFocus
      selectOnFocus
      autoHighlight
      noOptionsText="No matching timezones found"
      sx={{
        ...selectStyle,
        "& .MuiInputBase-input": {
          color: "var(--header__color)",
          WebkitTextFillColor: "var(--header__color)",
        },
        "& .MuiAutocomplete-popupIndicator": {
          color: "var(--header__color)",
        },
      }}
      slotProps={{
        popper: { sx: { zIndex: 1400 } },
        paper: {
          sx: {
            backgroundColor: "var(--body__background)",
            color: "var(--header__color)",
            "& .MuiAutocomplete-option": {
              color: "var(--header__color)",
              "&.Mui-focused, &[aria-selected='true']": {
                backgroundColor: "var(--tab__background)",
              },
            },
            "& .MuiAutocomplete-noOptions": {
              color: "var(--header__color)",
            },
          },
        },
      }}
      filterOptions={(options, { inputValue }) => {
        const terms = normalizeTimezoneSearch(inputValue).split(" ");
        return options.filter((timezone) => {
          const label = normalizeTimezoneSearch(timezone.label);
          return terms.every((term) => label.includes(term));
        });
      }}
    />
  );
};

export default TimezoneSelector;
